import React, { useRef, useState } from 'react';
import { Calendar, dateFnsLocalizer } from 'react-big-calendar';
import { format, parse, startOfWeek, getDay } from 'date-fns';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './CalendarComponent.css';
import CustomToolbar from './CustomToolbar';


const locales = {
  'en-US': require('date-fns/locale/en-US'),
};

const localizer = dateFnsLocalizer({
  format,
  parse,
  startOfWeek,
  getDay,
  locales,
});

const CalendarComponent = ({
  events = [],
  onSelectEvent,
  onAddEvent,
  selectedDate,
  onNavigate,
  components = {},
}) => {
  const calendarRef = useRef(null);
  const [currentView, setCurrentView] = useState('month');

  const handleSelectSlot = ({ start }) => {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    const selected = new Date(start);
    selected.setHours(0, 0, 0, 0);
    if (selected >= today) {
      onAddEvent(start);
    } else {
      alert('Cannot schedule events in the past.');
    }
  };

  const handleEventClick = (event) => {
    onSelectEvent(event);
  };

  const handleNavigate = (date) => {
    if (onNavigate) onNavigate(date);
  };

  const handleViewChange = (view) => {
    setCurrentView(view);
  };

  // Expand occurrences and deduplicate
  const expanded = events.flatMap(event => {
    if (event.occurrences?.length) {
      return event.occurrences.map(o => ({
        ...event,
        start: new Date(o.start),
        end: new Date(o.end),
      }));
    }
    return [{ ...event, start: new Date(event.start), end: new Date(event.end) }];
  });

  const seen = new Set();
  const deduped = [];

  for (const e of expanded) {
    const key = `${e.start.toISOString()}|${e.end.toISOString()}`;
    if (!seen.has(key)) {
      seen.add(key);
      deduped.push({ ...e });
    }
  }

  const mergedComponents = {
    event: (props) => <TimeOnlyEventComponent {...props} view={currentView} />,
    toolbar: components.toolbar || ((props) => <CustomToolbar {...props} />),
    ...components,
  };

  return (
    <div className="calendar-wrapper">
      <div className="calendar-container">
        <Calendar
          popup
          localizer={localizer}
          events={deduped}
          startAccessor="start"
          endAccessor="end"
          style={{ height: 500 }}
          selectable
          onSelectEvent={handleEventClick}
          onSelectSlot={handleSelectSlot}
          views={['month', 'week', 'day']}
          date={selectedDate}
          onNavigate={handleNavigate}
          onView={handleViewChange}
          view={currentView}
          components={mergedComponents}
        />
      </div>
    </div>
  );
};
export const TimeOnlyEventComponent = ({ event, view }) => {
  if (!event) return null;

  const start = event.start ? format(new Date(event.start), 'hh:mm aa') : '';
  const end = event.end ? format(new Date(event.end), 'hh:mm aa') : '';
  const timeRange = `${start} - ${end}`;

  return view === 'month' ? (
    <div
      style={{
        display: 'flex',
        alignItems: 'center',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        maxWidth: '100%',
        height: '20px',
        lineHeight: '20px',
      }}
      title={timeRange}
    >
      {timeRange}
    </div>
  ) : (
    <div style={{ height: '20px' }} />
  );
};
export default CalendarComponent;
